import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const updateSettlementReportFormatReq = (id: string, mid: string, updateObject: any, tokens: any, isSMID: any) => {
  delete updateObject?.isSmid
  const request: Request<{}> = {
    apiPath: APIEndPoints.updateSettlementReportFormat,
    method: 'POST',
    config: sitConfig(tokens),
    // headers: {
    //   'Content-Type': 'application/json',
    //   Authorization: userAccessToken,
    // },
    body: {
      inputFilter: {
        ...updateObject,
        merchantId: mid,
        isSMID: isSMID ? 'Y' : 'N',
      },
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { updateSettlementReportFormatReq }
